import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';
import Strong from '@tds/core-strong';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';

const SummaryAdditionalServices = ({ additionalServices, total }) => {
  return (
    <>
      {Object.keys(additionalServices).length === 0 && (
        <h4>No additional Services Selected</h4>
      )}
      {Object.keys(additionalServices).length > 0 && (
        <Box between={3}>
          <Heading level="h4">Additional Services</Heading>
          <table>
            <Thead>
              <Tr>
                <Th>Additional Services</Th>
                <Th>Unit</Th>
                <Th>Unit Price</Th>
                <Th>Total</Th>
              </Tr>
            </Thead>
            <tbody>
              {Object.keys(additionalServices).map(serviceName => {
                const { quantity, unitPrice } = additionalServices[serviceName];
                return (
                  <tr>
                    <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                      {serviceName}
                    </Td>
                    <Td>{quantity}</Td>
                    <Td>{getFormattedPricing(unitPrice)}</Td>
                    <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
                  </tr>
                );
              })}
              <Tr style={{ background: '#f4f4f4' }}>
                <Td colSpan={3}>
                  <Strong>Total</Strong>
                </Td>
                <Td>
                  <Strong>{getFormattedPricing(total)}</Strong>
                </Td>
              </Tr>
            </tbody>
          </table>
        </Box>
      )}
    </>
  );
};

SummaryAdditionalServices.propTypes = {
  additionalServices: PropTypes.objectOf(PropTypes.any).isRequired,
  total: PropTypes.number.isRequired
};

export default SummaryAdditionalServices;
